import React, { useState } from "react";
import { Share2, MessageCircle, Mail, Send, Link2, Check, Instagram, Youtube } from "lucide-react";
import { toast } from "sonner";

export const ShareButtons = ({ title, url, image }) => {
  const [copied, setCopied] = useState(false);
  const link = url || (typeof window !== "undefined" ? window.location.href : "");
  const text = `${title} — Joy Pearl`;
  const encoded = encodeURIComponent(`${text} ${link}`);

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, text, url: link }); }
      catch { /* user cancelled */ }
    } else {
      copyLink();
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true); toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Couldn't copy link"); }
  };

  const channels = [
    { label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${encoded}`, testid: "share-whatsapp" },
    { label: "Telegram", icon: Send, href: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`, testid: "share-telegram" },
    { label: "Email", icon: Mail, href: `mailto:?subject=${encodeURIComponent(text)}&body=${encoded}`, testid: "share-email" },
    { label: "Instagram", icon: Instagram, onClick: copyLink, hint: "Copy link → paste in IG", testid: "share-instagram" },
    { label: "YouTube", icon: Youtube, onClick: copyLink, hint: "Copy link → paste in YT", testid: "share-youtube" },
  ];

  return (
    <div className="mt-6" data-testid="share-buttons">
      <p className="jp-eyebrow mb-3 flex items-center gap-2"><Share2 size={12}/> Share this piece</p>
      <div className="flex flex-wrap gap-2">
        <button onClick={nativeShare} className="jp-btn-outline px-3 py-2 text-xs" data-testid="share-native">
          <Share2 size={13} className="mr-2"/> Share
        </button>
        {channels.map((c) => (
          c.href ? (
            <a key={c.label} href={c.href} target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-2 border border-brand-line bg-white px-3 py-2 text-xs hover:border-brand-primary hover:text-brand-primary transition-colors"
               data-testid={c.testid}>
              <c.icon size={13}/> {c.label}
            </a>
          ) : (
            <button key={c.label} onClick={c.onClick}
                    className="inline-flex items-center gap-2 border border-brand-line bg-white px-3 py-2 text-xs hover:border-brand-primary hover:text-brand-primary transition-colors"
                    title={c.hint} data-testid={c.testid}>
              <c.icon size={13}/> {c.label}
            </button>
          )
        ))}
        <button onClick={copyLink}
          className="inline-flex items-center gap-2 border border-brand-line bg-white px-3 py-2 text-xs hover:border-brand-primary hover:text-brand-primary transition-colors"
          data-testid="share-copylink">
          {copied ? <Check size={13}/> : <Link2 size={13}/>} {copied ? "Copied" : "Copy link"}
        </button>
      </div>
    </div>
  );
};
